import React from "react";
import { SquarePen, GraduationCap, Briefcase, Users, Hand } from "lucide-react";
import { SCROLL_OFFSET } from "./sections";

const AUDIENCES = [
  {
    icon: SquarePen,
    lead: "Writers and bloggers",
    body: " drafting posts faster by speaking first drafts instead of typing them line by line.",
  },
  {
    icon: GraduationCap,
    lead: "Students",
    body: " turning lecture notes or research thoughts into essays without slowing down to keep up with their own ideas.",
  },
  {
    icon: Briefcase,
    lead: "Business professionals",
    body: " dictating reports, proposals, and client emails between meetings.",
  },
  {
    icon: Users,
    lead: "Content teams",
    body: " producing more drafts per day without adding headcount.",
  },
  {
    icon: Hand,
    lead: "Anyone managing wrist or hand strain",
    body: " who needs a lower-effort way to keep writing.",
    fullWidth: true,
  },
];

const WhoUsesItSection = () => {
  return (
    <section
      id="who-uses-it"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full lg:max-w-[815.58px]"
    >
      <h2 className="font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]">
        Who Uses Voice Typing for Google Docs
      </h2>

      <div className="pt-[25.76px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[17.17px]">
          {AUDIENCES.map(({ icon: Icon, lead, body, fullWidth }) => (
            <article
              key={lead}
              className={`flex items-start gap-[17.17px] rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-white p-[16px] sm:p-[21.46px] ${
                fullWidth ? "md:col-span-2" : ""
              }`}
            >
              <span className="flex h-[34.34px] w-[34.34px] shrink-0 items-center justify-center rounded-[12.88px] bg-[#EBF7FE] text-[#3AB1F6]">
                <Icon className="h-[16px] w-[16px]" strokeWidth={1.8} />
              </span>

              <p className="font-jakarta text-[16.1px] font-normal leading-[26.16px] tracking-[0px] text-[#0A0D16B2]">
                <strong className="font-bold text-[#0A0D16]">{lead}</strong>
                {body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoUsesItSection;
